import { gql } from "@apollo/client";

export const GQL_TARI_BILL = gql`
   query tariBill($id: ID!) {
      tariBill(id: $id) {
         id
         tax_provider_id
         tax_provider {
            id
            company_name
         }
         tax_account_id
         tax_account {
            id
            code
            comune {
               id
               code
               description
            }
            client {
               id
            }
         }
         has_sent_dossier
         has_dossier
         reopened_at
         number
         issue_date
         tax_period_start
         tax_period_end
         fixed_amount
         variable_amount
         taxable_amount
         vat_amount
         province_additional_amount
         total_amount
         total_amount_calculated
         total_amount_forced
         closed
         forced_fields
         is_master
         bill_id
         child_bills {
            id
            number
            issue_date
         }
         rows {
            id
            tax_category_id
            tax_category {
               id
               code
               description
            }
            description #todo
            surface
            annual_coefficient
            fixed_cost
            variable_cost
            province_additional
            fixed_amount
            variable_amount
            taxable_amount
            province_additional_amount
            vat
            vat_amount
            total_amount
            forced_fields
            variations {
               id
               description
               value
               amount
               type
               target
            }
            recycle_variations {
               id
               expected_waste
               real_waste
               kd
               surface
               recycled_waste_percent
               recycled_waste_weight
               effective_production_potential
               target
               amount
               province_additional_amount
               percent
               total_amount
            }
         }
         additional_rows {
            id
            description
            taxable_amount
            vat
            vat_amount
            province_additional
            province_additional_amount
            total_amount
         }
         emptying_rows {
            id
            description
            bin_capacity
            quantity
            unit
            taxable_amount
            vat
            vat_amount
            province_additional
            province_additional_amount
            total_amount
         }
         perequative_rows {
            id
            bill_perequative_setting_id
            name
            taxable_amount
            vat
            vat_amount
            total_amount
         }
         payments_deadlines {
            id
            date
            amount
            paid_amount
            note
            payments {
               id
               date
               amount
               note
            }
         }
         asset {
            id
            bucket_key
            file_name
         }
      }
   }
`;

//Solo il comune dell'utenza della bolletta (usato dal pulsante Osservatorio TARI in topbar)
export const GQL_TARI_BILL_COMUNE = gql`
   query tariBillComune($id: ID!) {
      tariBill(id: $id) {
         id
         tax_account {
            id
            comune {
               id
               code
               description
            }
         }
      }
   }
`;

export const GQL_TARI_BILL_PAYMENTS = gql`
   query tariBill($id: ID!) {
      tariBill(id: $id) {
         id
         tax_provider {
            id
            company_name
         }
         tax_account {
            id
            code
            comune {
               id
               code
               description
            }
         }
         number
         issue_date
         total_amount
         total_amount_calculated
         total_amount_forced
         closed
         is_master
         tax_period_start
         tax_period_end
         payments_deadlines {
            id
            date
            amount
            note
            payments {
               id
               date
               amount
               note
            }
            #status
         }
      }
   }
`;

export const GQL_PAGINATED_TARI_BILLS = gql`
   query paginatedTariBills(
      $filter: TariBillFilterInput
      $first: Int
      $page: Int
      $orderBy: OrderByClause
   ) {
      paginatedTariBills(
         filter: $filter
         first: $first
         page: $page
         orderBy: $orderBy
      ) {
         data {
            id
            tax_provider {
               id
               company_name
               rid_contestuale
               rid_avvio_recupero
               rid_eccedenze_alimentare
            }
            tax_account {
               id
               code
            }
            number
            issue_date
            tax_period_start
            tax_period_end
            fixed_amount
            variable_amount
            taxable_amount
            province_additional_amount
            total_amount
            payments_deadlines_amount
            payments_amount
            payments_expired_amount
            closed
            rows {
               id
               surface
               tax_category {
                  id
                  code
                  description
               }
               annual_coefficient
               fixed_cost
               variable_cost
               province_additional
               fixed_amount
               variable_amount
               taxable_amount
               reductions_total
               province_additional_amount
               total_amount
            }
            child_bills {
               id
               number
               issue_date
               tax_period_start
               tax_period_end
               total_amount
            }
            additional_rows {
               id
               description
               taxable_amount
               vat
               vat_amount
               province_additional
               province_additional_amount
               total_amount
            }
            emptying_rows {
               id
               description
               bin_capacity
               quantity
               unit
               taxable_amount
               vat
               vat_amount
               province_additional
               province_additional_amount
               total_amount
            }
            perequative_rows {
               id
               bill_perequative_setting_id
               name
               taxable_amount
               vat
               vat_amount
               total_amount
            }
            asset {
               id
               bucket_key
               file_name
            }
         }
         paginatorInfo {
            count
            currentPage
            hasMorePages
            lastPage
            perPage
            total
         }
      }
   }
`;

export const GQL_CHART_TARI_BILLS = gql`
   query tariBills($filter: TariBillFilterInput) {
      tariBills(filter: $filter) {
         id
         number
         issue_date
         total_amount
         tax_account {
            id
            comune {
               id
               description
            }
            province {
               id
               code
               description
            }
         }
      }
   }
`;

export const GQL_TARI_BY_TAX_ACCOUNT = gql`
   query tariByTaxAccount($input: TariByTaxAccountInput) {
      tariByTaxAccount(input: $input) {
         id
         number
         issue_date
         tax_period_start
         tax_period_end
         total_amount
         is_master
      }
   }
`;

export const GQL_TARI_RANKING = gql`
   query tariRanking($year: Int!) {
      tariRanking(year: $year) {
         taxAccount {
            client {
               id
               company_name
            }
            id
            code
         }
         total
      }
   }
`;

export const GQL_TARI_EXPORTS = gql`
   query exportTariBills($input: TariExportXLSInput!) {
      exportTariBills(input: $input) {
         content
         filename
         filetype
      }
   }
`;

export const GLQ_TARI_BILL_DEADLINES = gql`
   query tariBillPaymentsDeadlines($filter: TariBillPaymentsDeadlinesFilterInput) {
      tariBillPaymentsDeadlines(filter: $filter) {
         id
         date
         amount
         paid_amount
         is_paid
         is_expired
         bill {
            id
            number
            issue_date
            total_amount
            payments_deadlines_count
            tax_account {
               id
               client {
                  id
                  company_name
               }
               comune {
                  id
                  description
               }
               province {
                  id
                  code
               }
            }
         }
      }
   }
`;

export const GQL_TARI_BILLS_ALL = gql`
   query tariBillsAll($input: TariBillsAllFilterInput!) {
      tariBillsAll(input: $input) {
         data {
            id
            number
            issue_date
            tax_period_start
            tax_period_end
            fixed_amount
            variable_amount
            province_additional_amount
            taxable_amount
            total_amount
            tax_provider {
               id
               company_name
            }
            tax_account {
               id
               code
               client {
                  id
                  company_name
               }
            }
            rows {
               surface
               tax_category {
                  id
                  code
                  description
               }
            }
         }
         paginatorInfo {
            current_page
            per_page
            total
            last_page
         }
      }
   }
`;

export const GQL_TARI_BILLS_EXPORT_ALL = gql`
   query exportTariBillsAll($input: TariBillsAllFilterInput!) {
      exportTariBillsAll(input: $input) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_CHART_TARI_BILLS_DEADLINES = gql`
   query tariBillsDeadlines($filter: TariBillDeadlinesFilterInput) {
      tariBillsDeadlines(filter: $filter) {
         id
         date
         amount
         paid_amount
         is_paid
         is_expired
         note
         bill {
            id
            number
            issue_date
            total_amount
            payments_deadlines_count
            tax_account {
               id
               code
               comune {
                  id
                  description
               }
               province {
                  id
                  code
               }
            }
         }
      }
   }
`;

export const GQL_TARI_DEADLINES_EXPORTS = gql`
   query exportTariBillsDeadlines($input: TariBillDeadlinesFilterInput!) {
      exportTariBillsDeadlines(input: $input) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_TARI_PEREQUATIVES_SETTINGS = gql`
   query tariBillPerequativeSettings($defaultOnly: Boolean) {
      tariBillPerequativeSettings(defaultOnly: $defaultOnly) {
         id
         name
         amount
         vat
         default
         created_at
         updated_at
      }
   }
`;
